// extracted by mini-css-extract-plugin
module.exports = {"article":"TextArticle_article__jgFV_","title":"TextArticle_title__blsTL"};